<div class="vocabulary-multidetail-container">
    <div class="card card-block">
        <div class="form-group row">
            <div class="col-md-12">
                <label class="card-text" for="term">TERM</label>
                <input class="form-control" cols="55" id="term" [(ngModel)]="vocabularyInfo.word">
                <button class="btn btn-outline-primary btn-sm"
                        (click)="searchTerm()">Search
                </button>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12" style="font-size:small"
                 *ngFor="let definitionOption of vocabularyInfo.definitionOptions;let idx = index">
                <input class="form-label"
                       type="radio"
                       name="def"
                       value={{idx}}
                       [checked]="vocabularyInfo.definitionIndex === idx"
                       (click)="setDefinition(idx)"> {{definitionOption.definition}}
                <div style="font-size:x-small" class="form-label"> {{definitionOption.context}}
                <div class="form-label indent"
                     *ngFor="let translationOption of definitionOption.translationOptions; let tidx = index">
                <input class="form-label indent"
                       type="radio"
                       name="trans"
                       value={{tidx}}
                       [checked]="vocabularyInfo.definitionIndex === idx && vocabularyInfo.translationIndex === tidx"
                       [disabled]="vocabularyInfo.definitionIndex !== idx"
                       (click)="setTranslation(tidx)"> {{translationOption.word}}
                </div>
            </div>
        </div>

        <div style="text-align:center" class="form-group row indent">
            <div class="col-md-12 btn-group-sm">
                <button class="btn btn-outline-primary btn-sm"
                        [disabled]="changeDisabled()" (click)="updateEntry()">Update
                </button>
                <button class="btn btn-outline-secondary btn-sm"
                        (click)="cancelEntry()">Cancel
                </button>
            </div>
        </div>
    </div>
</div>
